// extracted by mini-css-extract-plugin
export var mergingIntoPill = "_mp-1";
export var rowFirst = "_mp-3";
export var rowLast = "_mp-5";
export var rowMiddle = "_mp-4";
export var ticketListScroll = "_mp-2";
export var ticketStack = "_mp-0";